module.exports = {
    "crude": {
        "search": "Procurar",
        "actions": "Ações",
        "nextPage": "Próxima página",
        "lastPage": "Página anterior",
        "back": "Voltar",
        "empty": "vazio",
        "edit": "editar",
        "create": "criar",
        "data": "registro",
        "view": "mostrar",
        "delete": "Excluir",
        "save": "Salvar",
        "cancel": "Cancelar",
        "noContent": "Nenhuma entrada disponível. ",
        "resetFilter": "Redefina os filtros e veja mais conteúdo!",
        "createOwnTextField": "Crie seu próprio campo de texto",
        "textFieldName": "rótulo do campo de texto",
        "textFieldValue": "Conteúdo",
        "insertTextFieldLabel": "Por favor insira o nome do campo de texto!",
        "deleteTextField": "Excluir campo de texto",
        "success": "O salvamento foi bem-sucedido",
        "invalidDataFields": "Os seguintes campos de dados são inválidos:  ",
        "entries": "entradas",
        "entry": "entrada",
        "tabDetail": "detalhes",
        "entity": "entidade",
        "of": "de",
        "uploadNewFile": "Subir arquivo",
        "upload": "carregar",
        "confirm": "OK",
        "deleteFileQuestion": "Você realmente deseja excluir este arquivo? ",
        "deleteFileQuestionTitle": "Perigo!",
        "deleteEntityQuestion": "Você realmente deseja excluir esta entidade? ",
        "deleteEntityQuestionTitle": "Perigo!",
        "errorLargeFileUpload": "O arquivo selecionado é muito grande!",
        "useCroppedImage": "Usar corte",
        "useOriginalImage": "Usar imagem original",
        "available": "disponível",
        "searchColumn": "encontrar coluna",
        "manageColumns": "Gerenciar colunas",
        "hideColumn": "ocultar coluna",
        "pinToRight": "Fixar coluna à direita",
        "pinToLeft": "Fixar coluna à esquerda",
        "sortAsc": "Ordernar ascendente",
        "sortDesc": "Classificar em ordem decrescente",
        "hideAll": "esconder tudo",
        "showAll": "Mostre tudo",
        "preview": "visualização",
        "title": "título",
        "description": "Descrição",
        "tooltip": "dica de ferramenta",
        "sort": "ordenar por",
        "settings": "Configurações",
        "incomingReference": "referência",
        "language": "Linguagem",
        "deleteTabQuestionTitle": "Perigo!",
        "deleteTabQuestion": "Você realmente deseja excluir esta guia? ",
        "deleteElementQuestionTitle": "Perigo!",
        "deleteElementQuestion": "Você realmente deseja excluir este item? ",
        "configurationEditorDescriptionStringLayout": "Nesta coluna podem ser selecionadas três variantes para inserção do texto:",
        "configurationEditorDescriptionEnumLayout": "Duas variantes podem ser selecionadas para a seleção dos elementos nesta coluna:",
        "configurationEditorDescriptionBooleanLayout": "Duas variantes podem ser selecionadas para a seleção dos elementos nesta coluna:",
        "configurationEditorDescriptionForeignEntityLayout": "Duas variantes podem ser selecionadas para a seleção dos elementos nesta coluna:",
        "stringLayoutsingleline": "única linha",
        "stringLayoutmultiline": "multilinha",
        "stringLayouteditor": "Editor de Rich Text",
        "enumLayoutradio": "botao de radio",
        "enumLayoutdropdown": "suspenso",
        "booleanLayoutcheckbox": "caixa de seleção",
        "booleanLayoutswitch": "comuta",
        "foreignEntityLayoutpopUp": "Aparecer",
        "foreignEntityLayoutautocomplete": "suspenso",
        "foreignEntityLayoutlist": "lista",
        "formatTooltipbold": "Gordo",
        "formatTooltipitalic": "itálico",
        "formatTooltipunderline": "sublinhado",
        "formatTooltipstrike": "Riscado",
        "formatTooltipclean": "limpar formatação",
        "formatTooltipcodeBlock": "código",
        "formatTooltipblockquote": "Citar",
        "formatTooltipcolor": "cor da fonte",
        "formatTooltipbackground": "cor de fundo",
        "formatTooltipfont": "Fonte",
        "formatTooltipalign": "alinhamento",
        "formatTooltipheader": "tamanho da fonte",
        "formatTooltipsuper": "Sobrescrito",
        "formatTooltipsub": "subscrito",
        "formatTooltipordered": "Lista ordenada",
        "formatTooltipbullet": "Enumeração",
        "true": "Sim",
        "false": "não",
        "selectEntity": "selecione entidade",
        "filter": "filtro",
        "useFilter": "Aplicar filtros",
        "defaultFilter": "redefinir filtro",
        "expand": "expandir",
        "hide": "esconder",
        "minimumSelectionError": "Pelo menos {{min}} entradas devem ser selecionadas.",
        "maximumSelectionError": "Um máximo de {{max}} entradas podem ser selecionadas."
    }
}
;